import React, { Component } from 'react'
import { render } from 'react-dom'
import Usage from './Usage'
import Deployments from './Deployments'
import HAProxy from './HAProxy'
import Async from './Async'
import './Style.css'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import 'react-tabs/style/react-tabs.css'

class App extends Component {
  constructor() {
    super();
    var tabI = window.location.hash
    if(tabI) {
      this.state = { tabIndex: parseInt(tabI.substring(1), 10) };
    } else {
      this.state = { tabIndex: 0 };
    }
    
  }

  handleTabChange(tabI) {
    document.location.hash = tabI.tabIndex
    this.setState({
      tabIndex: tabI.tabIndex
    })
  } 

  render() {
    return (
      <Tabs defaultIndex={this.state.tabIndex} onSelect={tabIndex => this.handleTabChange({ tabIndex })}>
        <TabList>
          <Tab>Usage</Tab>
          <Tab>Deployments</Tab>
          <Tab>Sync</Tab>
          <Tab>Async</Tab>
        </TabList>
        <TabPanel>
          <Usage/>
        </TabPanel>
        <TabPanel>
          <Deployments/>
        </TabPanel>
        <TabPanel>
          <HAProxy/>
        </TabPanel>
        <TabPanel>
          <Async/>
        </TabPanel>
      </Tabs>
    );
  }
}

render(<App />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js